import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ServicePointModel} from '../models/service-point.model';

@Injectable({providedIn: 'root'})
export class ServicePointsHttpService {

  private base_url = `/servicepoint`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getAll(params?: { limit?: number; sort?: string; branchIds?: string[]; query?: string; cursor?: string }): Observable<{ cursor: string, list: ServicePointModel[] }> {
    return this.http
      .get<{ cursor: string, list: ServicePointModel[] }>(this.base_url, {params: params as any});
  }

  getOne(id: string): Observable<ServicePointModel> {
    return this.http
      .get<ServicePointModel>(`${this.base_url}/${id}`);
  }

}
